export default __webpack_public_path__ + "static/media/eidu26_header_desktop.e5b5f154.png";